// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
// import config from 'config';
import Logo from '../../../assets/images/ncr-logo.png';
// import { MENU_OPEN } from 'store/actions';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  // const defaultId = useSelector((state) => state.customization.defaultId);
  // const dispatch = useDispatch();
  return (
    <ButtonBase disableRipple>
       <img src={Logo} alt='NCR VOYIX' style={{width:'140px',height:'55px'}}/> 
    </ButtonBase>
   
  );
};

export default LogoSection;
